export default {
    data() {
        return {
            setupLoading: false,
            setupLoaded: false,
            setupOnMounted: true,
            setupRestricted: false,
            afterSetupArgs: {},
            trySetupDebounced: this._.debounce(this.trySetup, 100)
        };
    },
    async mounted() {
        this.checkSetupRestrictions();

        if (this.setupOnMounted && !this.setupRestricted) {
            await this.trySetup();
        }
    }
    // watch: {
    //     setupRestricted(isNowRestricted) {
    //         if (!isNowRestricted && !this.setupLoaded) {
    //             this.trySetup();
    //         }
    //     }
    // }
};

export const methods = {
    async trySetup(args) {
        if (this.setupRestricted) {
            return;
        }

        this.setupLoading = true;
        await this.setup(args);
        await this.afterSetup(this.afterSetupArgs);
        this.setupLoading = false;
        this.setupLoaded = true;
    },
    async setup() {},
    async afterSetup() {},
    checkSetupRestrictions() {
        this.setupRestricted = false;
    }
};
